import { getIndustrialProcessWording } from "#shared/helpers/getIndustrialProcessWording";
import { DefaultProcessStep, OnboardingProcessStep } from "shared";

export type ProcessStepOption = {
  value: string;
  label: string;
  description: string | null;
};

export const getProcessStepOptions = (
  processSteps: OnboardingProcessStep[],
  existingProcessSteps: DefaultProcessStep[],
): ProcessStepOption[] => {
  return processSteps
    .filter(
      (processStep) =>
        !existingProcessSteps.some(
          (existingProcessStep) =>
            existingProcessStep.industrialProcess === processStep.industrialProcess &&
            existingProcessStep.description === processStep.machineName,
        ),
    )
    .map(({ id, industrialProcess, machineName }) => {
      const label = getIndustrialProcessWording(industrialProcess);

      return {
        value: id,
        label,
        description: machineName,
      };
    })
    .toSorted((a, b) => a.label.localeCompare(b.label));
};
